import type { ActivityType } from '@common/enums';
import type { ServiceChoiceWithEpisodeCategory } from '@common/validation/schemas';
import { FinancialReportType } from '@common/enums';
import {
    getFinancialReportColumns,
    getFundingReportColumns,
    getPayoutsReportColumns,
} from '@common/financialExport/financialExportColumns';
import { getSelectedLanguage } from '@frontend/translate';

export interface ISearchBase {
    activityTypeChoice?: ActivityType;
    episodeCategoryId: string | null;
    serviceChoice: ServiceChoiceWithEpisodeCategory | null;
    serviceId: string | null;
}

export interface ISearchParams extends ISearchBase {
    endDate?: Date;
    startDate?: Date;
}

export interface ISearchRequest extends ISearchBase {
    endDate?: string;
    startDate?: string;
}

export interface IColumnData {
    data: {
        badgeText: string;
        key: string;
        label: string;
        sensitiveData?: boolean | null;
        value: string;
    }[];
    name: string;
}

export function getDataColumns(reportType?: FinancialReportType) {
    if (!reportType) {
        return;
    }

    return {
        complete: getFinancialReportColumns(),
        funding: getFundingReportColumns(),
        payouts: getPayoutsReportColumns(),
    }[reportType];
}

export function getHeaderText(reportType?: FinancialReportType) {
    const language = getSelectedLanguage();

    if (!reportType) {
        return;
    }

    switch (reportType) {
        case FinancialReportType.complete:
            return language.finance.financialReport;
        case FinancialReportType.payouts:
            return language.finance.payoutsReport;
        default:
            return language.finance.fundingReport;
    }
}
